import React from "react";
import PropTypes from "prop-types";
import { SimpleForm, Button } from "simple-ui-components";
import { getTranslation } from "../languageProvider";
import DatePickerHolder from "./datePickerHolder";

const FormHooks = ({
  formInputs,
  inputChange,
  hideError = false,
  onSubmit,
  size = "md",
  layout = "outline",
}) => {
  const { Form, InputGroup } = SimpleForm;
  const formElement = [];
  for (let key in formInputs) {
    formElement.push({
      id: key,
      config: formInputs[key],
    });
  }
  if (formElement.length === 0) return null;
  return (
    <Form size={size} layout={layout} onSubmit={onSubmit}>
      {formElement.map((el) => {
        if (el.id === "submit") {
          if (el.config.isSubmit) {
            return (
              <Button
                key={el.id}
                type={el.config.type}
                className={`${el.config.className ? el.config.className : ""} ${
                  el.config.valid ? "" : "disabled"
                }`}
                theme={el.config.valid ? "default" : "disabled"}
                clicked={el.config.clicked && el.config.clicked()}
                ref={el.config.inputRef}
                icon={el.config.icon}
                text={getTranslation(el.config.text)}
              />
            );
          } else {
            return null;
          }
        } else {
          if (el.config.visibility === "hide") return null;
          if (el.config.type === "autocomplete")
            return (
              <InputGroup
                key={el.id}
                className={
                  !hideError && !el.config.valid && el.config.touched
                    ? "error"
                    : ""
                }
                icon={el.config.icon}
                type={el.config.type}
                name={el.id}
                placeholder={el.config.label && getTranslation(el.config.label)}
                ref={el.config.inputRef && el.config.inputRef}
                inputElement={{
                  onChange: (e) => inputChange(e, el.id),
                  value: el.config.value,
                  className:
                    el.config.value || el.config.value === 0 ? "focused" : "",
                  translate: el.config.label,
                  ...el.config.input,
                }}
              />
            );
          if (el.config.type === "checkbox")
            return (
              <InputGroup
                key={el.id}
                type="checkbox"
                name={el.config.name}
                placeholder={el.config.placeholder && el.config.placeholder}
                inputElement={{
                  onChange: (e) => inputChange(e, el.id),
                  label: el.config.label && getTranslation(el.config.label),
                }}
              />
            );
          if (el.config.type === "date" || el.config.type === "time")
            return (
              <InputGroup
                key={el.id}
                type="date"
                name={el.config.name && el.config.name}
                placeholder={el.config.label && getTranslation(el.config.label)}
              >
                <DatePickerHolder
                  elements={{
                    type: el.config.type,
                    onChange: el.config.onChange,
                    name: el.config.name && el.config.name,
                    value: el.config.value,
                    maxDate: el.config.maxDate && el.config.maxDate,
                    minDate: el.config.minDate && el.config.minDate,
                  }}
                />
              </InputGroup>
            );
          return (
            <InputGroup
              key={el.id}
              className={
                !hideError && !el.config.valid && el.config.touched
                  ? "error"
                  : ""
              }
              icon={el.config.icon}
              type={el.config.type}
              name={el.id}
              placeholder={el.config.label && getTranslation(el.config.label)}
              ref={el.config.inputRef && el.config.inputRef}
              inputElement={{
                onChange: (e) => inputChange(e, el.id),
                defaultValue: el.config.value,
                className:
                  el.config.value || el.config.value === 0 ? "focused" : "",
                translate: el.config.label,
                ...el.config.input,
              }}
            />
          );
        }
      })}
    </Form>
  );
};

FormHooks.propTypes = {
  formInputs: PropTypes.object.isRequired,
  inputChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["lg", "md", "sm"]).isRequired,
  layout: PropTypes.oneOf(["outline", "default"]).isRequired,
  hideError: PropTypes.bool,
};

export default FormHooks;
